export default __webpack_public_path__ + "static/media/twitter.e5a04b65.svg";